import { render, staticRenderFns } from "./createProduct.vue?vue&type=template&id=21f8cb24&scoped=true&"
import script from "./createProduct.vue?vue&type=script&lang=js&"
export * from "./createProduct.vue?vue&type=script&lang=js&"
import style0 from "./createProduct.vue?vue&type=style&index=0&id=21f8cb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8cb24",
  null
  
)

export default component.exports